import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BackendDeleteResponse, Datastore } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontSize } from '@freelancer/ui/text';

@Component({
  template: `
    <fl-bit class="MainBody" flTrackingSection="DiscoverManageDeleteModal">
      <fl-heading
        i18n="Delete portfolio modal title"
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H1"
        [flMarginBottom]="Margin.XXSMALL"
      >
        Delete portfolio item
      </fl-heading>
      <fl-text
        i18n="Delete portfolio modal subtitle"
        [flMarginBottom]="Margin.LARGE"
      >
        You can't undo this action.
      </fl-text>
      <fl-grid>
        <fl-col [col]="12" [colDesktopSmall]="6">
          <fl-text
            *ngIf="(deletePromise | async)?.status == 'error'"
            i18n="Delete portfolio modal error message"
            [color]="FontColor.ERROR"
            [size]="FontSize.SMALL"
            [flMarginBottom]="Margin.XXSMALL"
          >
            Something went wrong while deleting this portfolio item. Please try
            again.
          </fl-text>
        </fl-col>

        <fl-col class="ActionContainer" [col]="12" [colDesktopSmall]="6">
          <fl-button
            i18n="Delete portfolio modal cancel button"
            flTrackingLabel="DeleteModalCloseButton"
            [color]="ButtonColor.TRANSPARENT_DARK"
            [flMarginRight]="Margin.SMALL"
            [busy]="deletePromise && (deletePromise | async) === null"
            (click)="deletePortfolio(portfolioId)"
          >
            Delete
          </fl-button>
          <fl-button
            i18n="Delete portfolio modal delete button"
            flTrackingLabel="DeleteModalDeleteButton"
            [color]="ButtonColor.SECONDARY"
            (click)="close()"
          >
            Go Back
          </fl-button>
        </fl-col>
      </fl-grid>
    </fl-bit>
  `,
  styleUrls: ['./discover-manage-delete-modal.component.scss'],
})
export class DiscoverManageDeleteModalComponent {
  ButtonColor = ButtonColor;
  IconSize = IconSize;
  FontColor = FontColor;
  FontSize = FontSize;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  Margin = Margin;

  deletePromise: Promise<BackendDeleteResponse<'showcase'>>;
  @Input() portfolioId: number;
  @Input() redirectUrl?: string;

  constructor(
    private modalRef: ModalRef<DiscoverManageDeleteModalComponent>,
    private datastore: Datastore,
    private router: Router,
  ) {}

  close() {
    this.modalRef.close();
  }

  deletePortfolio(id: number) {
    this.deletePromise = this.datastore
      .document('showcase', id)
      .remove()
      .then(response => {
        if (response.status === 'success') {
          this.close();
          if (this.redirectUrl) {
            this.router.navigate([this.redirectUrl]);
          }
        }
        return response;
      });
  }
}
